export default __webpack_public_path__ + "static/media/roadmap_5.f1787b1e.png";